import NishantProfile from "./assets/images/nishant-profile.png";
import VipulProfile from "./assets/images/vipul-profile.png";
import KunalProfile from "./assets/images/kunal-profile.png";
import DagarProfile from "./assets/images/dagar-profile.jpeg";
import RupaliProfile from "./assets/images/rupali-profile.png";
import CapgridLogo from "./assets/logos/capgrid-logo.png";
import Email from "./assets/icons/email.svg";
import Linkedin from "./assets/icons/linkedin.svg";
import Instagram from "./assets/icons/instagram.svg";
import Whatsapp from "./assets/icons/whatsapp.svg";
import ReactLogo from "./assets/logos/React-logo.webp";
import JsLogo from "./assets/logos/js-logo-removebg-preview.png";
import MongoLogo from "./assets/logos/mongo-logo-removebg-preview.png";
import ExpressLogo from "./assets/logos/express-logo.webp";
import NodeLogo from "./assets/logos/node-logo-removebg-preview.png";
import TsLogo from "./assets/logos/ts-logo-removebg-preview.png";
import StorybookLogo from "./assets/logos/storybook-logo.png";
import MUILogo from "./assets/logos/MUI-logo-removebg-preview.png";
import GQLLogo from "./assets/logos/graphql-logo-removebg-preview.png";
import VeronaLogo from "./assets/logos/veronaLogo.png";
import FreelancerImg from "./assets/logos/freelancerImg.png";

export const SDE_1_DETAILS = [
  "Pioneered the creation of a custom UI library, unlocking the ability to generate dynamic 3D visualizations of mechanical auto parts using Three.js, pushing the boundaries of interactive design.",
  "Launched a comprehensive Storybook design system, seamlessly integrating over 13 custom UI components into the project, setting a new standard for consistency and modularity in our UI development.",
  "Implemented cutting-edge MongoDB Atlas search capabilities, crafting a highly reusable and intuitive Autocomplete UI that transformed the user search experience.",
  "Engineered progressive filtering APIs that empowered users to easily refine and access data, delivering smoother, more efficient interactions.",
  "Developed a powerful, custom API that synchronized frontend and backend data flows, slashing response times by 40% and significantly improving user satisfaction across platforms.",
];

export const VERONA_DETAILS = [
  "Contributed to a production mobile app (iOS & Android) on React Native and TypeScript, working across navigation, state (Redux + persistence), and API integration (auth-aware HTTP client, retries, error states).",
  "Helped ship monetization flows using in-app purchases,tying store purchases to backend verification, completion/finish steps, and success/failure analytics for subscriptions and one-time products.",
  "Built user-facing trust & onboarding experiences, including camera-based liveness with real-time face checks and guided UI (Vision Camera + frame processing).",
  "Implemented AI-assisted profile insights in-app (bottom sheet UX with loading/retry, progressive reveal, and user feedback to the backend).",
  "Supported quality and releases with crash reporting (Sentry), over-the-air updates (CodePush), and product analytics (e.g. PostHog with session replay considerations), plus staging/production environment workflows.",
];

export const CAPGRID_INTERN_DETAILS = [
  "Spearheaded the implementation of responsive, accessible design, ensuring flawless compatibility across all devices and browsers, which led to a 25% surge in user engagement.",
  "Supercharged web application performance by integrating advanced JavaScript and TypeScript techniques, boosting speed by 20% and elevating the user experience to new heights.",
  "Transformed the application’s load efficiency with lazy loading for components and images, creating a smoother, faster browsing experience.",
];

export const FREELANCE_DETAILS = [
  "Designed and architected a scalable shift assignment system for an airline, prioritizing seniority and skillset for over 100 staff members. This system significantly enhanced operational efficiency during peak service times, ensuring seamless flight operations.",
  "Crafted an advanced shift prioritization system tailored to the airline's needs, optimizing staffing levels during high-demand periods, and directly improving service quality and overall business performance.",
  "Leveraged modern frontend technologies like ReactJS, Redux, CSS3, and MUI to deliver sleek, responsive, and scalable features across devices, empowering airline staff with intuitive, performance-driven tools.",
];

export const SKILL_DETAILS = {
  REACT_JS:
    "I've been vibing with ReactJS for 2 years, building smooth and responsive web apps. With hooks, routing, and API integration, I’ve got the front-end game on lock.",
  JAVASCRIPT:
    "After 2 years grinding with JavaScript, I’ve mastered ES6+ features and async code. Writing clean, efficient scripts is my jam, especially when handling APIs.",
  MONGO_DB:
    "I’ve been flexing my skills with MongoDB for a year, crafting dope NoSQL databases. I’m all about fast queries and keeping data organized with that document storage vibe.",
  EXPRESS_JS:
    "Express.js has been my sidekick for server-side apps, where routing and middleware are no sweat. It’s the key to building fast, reliable APIs.",
  NODE_JS:
    "I've been diving into Node.js for a year, creating efficient backends and handling async tasks with ease. Its seamless integration with Express and MongoDB makes it a solid tool for scalable apps.",
  TYPESCRIPT:
    "In the last year, TypeScript has been a total game-changer for both front and back end. Its type safety, keeps my code clean, and reduces bugs, making development way smoother.",
  STORYBOOK:
    "Storybook has been my go-to for building and showcasing UI components in isolation, helping me tweak and test everything until it’s looking fresh.",
  MUI: "I’ve spent 2 years cruising with MUI, using its components to keep my UI sharp and consistent. The material design ensures my projects always look polished and professional.",
  GRAPH_QL:
    "GraphQL has been my go-to for fetching data efficiently, without all the unnecessary payload. Its intuitive syntax makes querying a breeze compared to old-school methods.",
};

export const TESTEMONIALS = [
  {
    content:
      "Abhinav has consistently demonstrated an eagerness to embrace new challenges and technologies. His willingness to experiment and try new approaches has not only enhanced his own skill set but has also inspired those around him to push their boundaries. \nOne of Abhinav's standout qualities is his excellent communication skills. He effectively articulates his ideas and actively engages with team members, fostering a collaborative environment that promotes innovation and problem-solving. \nMoreover, Abhinav goes beyond just writing code; he takes the time to understand the business context behind our projects. This holistic approach allows him to deliver solutions that align with our goals and truly meet the needs of the users. \nIn summary, Abhinav is a remarkable talent with a bright future ahead. His dedication and passion for his work makes him an invaluable member of any engineering department.",
    name: "Nishant Gupta",
    title: "Director - Technology @Capgrid ex Zetwerk, IIT Kanpur",
    image: NishantProfile,
    link: "https://www.linkedin.com/in/nishant-gupta-2b128a3a/",
  },
  {
    content:
      "I had the pleasure of collaborating with Abhinav on several web development projects, and I can confidently say he is one of the most talented and dedicated developers I've encountered. His expertise in the MERN stack (MongoDB, Express.js, React.js, and Node.js) is exceptional. \nI highly recommend Abhinav to anyone seeking a skilled and reliable MERN stack developer. His work ethic, technical knowledge, and problem-solving abilities make him an invaluable asset to any development team.",
    name: "Vipul Kumar",
    title: "Senior Manager II @Flipkart, ex Amazon and PwC",
    image: VipulProfile,
    link: "https://www.linkedin.com/in/kvipul91/",
  },

  {
    content:
      "As the Director of Sourcing, I had the chance to work closely with Abhinav on a project where he was instrumental in developing and implementing our web platform. Throughout the project, I was impressed by his professionalism, technical expertise, and dedication to delivering high-quality work. \nAbhinav showed a deep understanding of web development and worked seamlessly with our team to ensure that every feature and functionality was built according to our needs. He was able to take complex requirements and turn them into user-friendly, responsive solutions, making the platform both functional and visually appealing. \nBased on my experience working with Abhinav, I would highly recommend him to anyone looking for a skilled and dependable web developer. His technical abilities and strong work ethic would be a valuable addition to any team.",
    name: "Mahender Dagar",
    title: "Director - Sourcing @Capgrid ex Sonalika, Hero",
    image: DagarProfile,
    link: "https://www.linkedin.com/in/mahender-dagar-1350a025b/",
  },
  {
    content:
      "I had the opportunity to work with Abhinav on a project where his skills as a MERN Stack developer were truly valuable. His knowledge of MongoDB, Express.js, React.js, and Node.js allowed them to build a solid, functional web application that met the project’s goals. \nAbhinav demonstrated good proficiency in both front-end and back-end development, ensuring the user interface was responsive and the back-end was well-structured. He was always open to feedback and worked collaboratively with the team, which made the development process smooth and efficient. \nHe also approached challenges with a practical mindset, solving problems effectively as they arose. His attention to delivering within the timeline and adhering to project requirements was commendable. \nOverall, I found Abhinav to be reliable and knowledgeable, and I would recommend him to anyone seeking a capable MERN Stack developer.",
    name: "Kunal",
    title: "SDE-3 @Capgrid ex KOGO",
    image: KunalProfile,
    link: "https://www.linkedin.com/in/ks-kunal-sharma/",
  },
  {
    content:
      "Working with Abhinav on our project was a fantastic experience. His expertise in Node.js, MongoDB, and RESTful APIs helped us build a scalable, efficient application. He consistently delivered clean, well-structured code, and his use of tools like Git, Docker, and Jenkins ensured a smooth development process. \nAbhinav was proactive in solving issues, optimizing performance, and communicating technical details clearly. I’m very satisfied with the results and look forward to working with him again. I highly recommend him for any development project.",
    name: "Rupali",
    title: "Program Manager @Capgrid",
    image: RupaliProfile,
    link: "https://www.linkedin.com/in/rupali-saini-9b0448193/",
  },
];

export const PROFILE_SUMMARY =
  " Your go-to dev who's all about turning wild ideas into reality with killer code. From building apps that just work to making sure systems run smoother than your morning coffee, I am always up for the next challenge. Tech-savvy, creative, and always ahead of the curve—if it’s digital, I am on it. Ready to vibe with the future of tech? So am I.";

export const EXPERIENCES = [
  {
    name: "Verona Matchmaking",
    dates: "May 2025 - Present",
    link: "https://verona.club",
    details: VERONA_DETAILS,
    post: "App Developer",
    image: VeronaLogo,
  },
  {
    name: "Capgrid Solutions",
    dates: "January 2024 - July 2024",
    link: "https://capgrid.in/",
    details: SDE_1_DETAILS,
    post: "SDE-1",
    image: CapgridLogo,
  },
  {
    name: "Capgrid Solutions",
    dates: "July 2023 - December 2023",
    link: "https://capgrid.in/",
    details: CAPGRID_INTERN_DETAILS,
    post: "SDE-Trainee",
    image: CapgridLogo,
  },
  {
    name: "Freelance",
    dates: "November 2022 - May 2022",
    details: FREELANCE_DETAILS,
    post: "Frontend Developer",
    image: FreelancerImg,
  },
];

export const QUOTE = {
  MESSAGE: "Technology is best when it brings people together",
  AUTHOR: "Matt Mullenweg",
};

export const RESUME_LINK =
  "https://drive.google.com/file/d/1jDtLGT6C2Ju8UBBCLl9VhuGNAwpSHu7d/view?usp=drive_link";

export const SOCIAL_MEDIA_MAP = [
  {
    platform: "email",
    icon: Email,
    link: "mailto:abhinavsingh6633@gmail.com",
  },
  {
    platform: "linkedin",
    icon: Linkedin,
    link: "https://linkedin.com/in/abhinavsingh654/",
  },
  {
    platform: "instagram",
    icon: Instagram,
    link: "https://www.instagram.com/rajputabhinav654/",
  },
  {
    platform: "whatsapp",
    icon: Whatsapp,
    link: "wa.me/+918587093885",
  },
];

export const SKILL_SET = [
  {
    name: "React Js",
    image: ReactLogo,
    rating: 5,
    backContent: SKILL_DETAILS.REACT_JS,
  },
  {
    name: "JavaScript",
    image: JsLogo,
    rating: 5,
    backContent: SKILL_DETAILS.JAVASCRIPT,
  },
  {
    name: "Mongo Db",
    image: MongoLogo,
    rating: 3,
    backContent: SKILL_DETAILS.MONGO_DB,
  },
  {
    name: "Express Js",
    image: ExpressLogo,
    rating: 3,
    backContent: SKILL_DETAILS.EXPRESS_JS,
  },
  {
    name: "Node Js",
    image: NodeLogo,
    rating: 4,
    backContent: SKILL_DETAILS.NODE_JS,
  },
  {
    name: "TypeScript",
    image: TsLogo,
    rating: 5,
    backContent: SKILL_DETAILS.TYPESCRIPT,
  },
  {
    name: "Storybook",
    image: StorybookLogo,
    rating: 4,
    backContent: SKILL_DETAILS.STORYBOOK,
  },
  {
    name: "Material UI",
    image: MUILogo,
    rating: 5,
    backContent: SKILL_DETAILS.MUI,
  },
  {
    name: "Graphql",
    image: GQLLogo,
    rating: 4,
    backContent: SKILL_DETAILS.GRAPH_QL,
  },
];
